import { render, staticRenderFns } from "./FlodTextBox.vue?vue&type=template&id=38482fa8"
import script from "./FlodTextBox.vue?vue&type=script&lang=js"
export * from "./FlodTextBox.vue?vue&type=script&lang=js"
import style0 from "./FlodTextBox.vue?vue&type=style&index=0&id=38482fa8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports